"use client"

import { MessageCircleX } from "lucide-react"
import { component, Icon } from "../icon"

/**
 * `MessageCircleXIcon` is [Lucide](https://lucide.dev) SVG icon component.
 *
 * @see https://yamada-ui.com/docs/components/icon
 */
export const MessageCircleXIcon = component(Icon)({ as: MessageCircleX })
